import React, { useEffect, useState } from "react";
import MainContainer from "../../container/MainContainer";
import search from "../../images/d-search.svg";
import { Tab, Nav, Spinner } from "react-bootstrap";
import { useLazyQuery, useQuery, useMutation } from "@apollo/react-hooks";
import { GET_DEALS } from "../../query/getDeals";
import { hasuraClient } from "../../apolloClient";
import DealList from "./DealList";
import { Link } from "react-router-dom";
import { GET_DEALS_COUNT } from "../../query/getDealCount";
import { DELETE_DEAL } from "../../mutation/deleteDeal";
import DeleteModal from "../Common/DeleteModal";
import moment from "moment";

const DealLayout = () => {
  const [eventKey, setEventKey] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const [modalShowD, setModalShowD] = useState(false);
  const [currentDealId, setCurrentDealId] = useState(null);
  const [refreshList, setRefreshList] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [getDeals, { data: deals, loading: dealsLoading, error: dealsError }] =
    useLazyQuery(GET_DEALS, {
      fetchPolicy: "cache-and-network",
      client: hasuraClient,
    });

  const [deleteDeal] = useMutation(DELETE_DEAL, {
    client: hasuraClient,
  });

  const { data: freebiesCount } = useQuery(GET_DEALS_COUNT, {
    client: hasuraClient,
    fetchPolicy: "cache-and-network",
    variables: {
      business_profile_id: localStorage.getItem("profile_id"),
      club_profile_id: localStorage.getItem("profile_id"),
      type: "freebies",
      current_date_time: moment().format(),
    },
  });

  const { data: discountCount } = useQuery(GET_DEALS_COUNT, {
    client: hasuraClient,
    fetchPolicy: "cache-and-network",
    variables: {
      business_profile_id: localStorage.getItem("profile_id"),
      club_profile_id: localStorage.getItem("profile_id"),
      type: "discount",
      current_date_time: moment().format(),
    },
  });

  const { data: buy_1_get_1_freeCount } = useQuery(GET_DEALS_COUNT, {
    client: hasuraClient,
    fetchPolicy: "cache-and-network",
    variables: {
      business_profile_id: localStorage.getItem("profile_id"),
      club_profile_id: localStorage.getItem("profile_id"),
      type: "buy_1_get_1_free",
      current_date_time: moment().format(),
    },
  });

  useEffect(() => {
    getDeals({
      variables: {
        searchText: "%%",
        id: localStorage.getItem("profile_id"),
        type: null,
        current_date_time: moment().format(),
      },
    });
  }, []);

  useEffect(() => {
    getDeals({
      variables: {
        searchText: `%${searchKey}%`,
        id: localStorage.getItem("profile_id"),
        type: eventKey,
        current_date_time: moment().format(),
      },
    });
  }, [searchKey, eventKey, refreshList]);

  const DeleteDealFun = (id) => {
    setDeleteLoading(true);
    deleteDeal({
      variables: {
        id: id,
      },
    })
      .then((res) => {
        setDeleteLoading(false);
        setCurrentDealId(null);
        setModalShowD(false);
        setRefreshList(!refreshList);
      })
      .catch(() => {
        setDeleteLoading(false);
      });
  };

  return (
    <MainContainer active="deals">
      {currentDealId && modalShowD ? (
        <DeleteModal
          deleteEventHandler={DeleteDealFun}
          show={modalShowD}
          onHide={() => setModalShowD(false)}
          id={currentDealId}
          deleteLoading={deleteLoading}
        />
      ) : (
        ""
      )}
      <section className="post-block">
        <div className="main-title">
          <h1>Deal</h1>
          <div className="search-col">
            <div className="search-input">
              <input
                type="text"
                className="form-control"
                placeholder="Search ..."
                onChange={(e) => {
                  setSearchKey(e.target.value);
                  setEventKey(null);
                }}
                value={searchKey}
              />
              <button className="search">
                <img src={search} alt="search icon" />
              </button>
            </div>
            <div className="deal-btn">
              <Link to="/createdeal" className="primary-button">
                Create deals
              </Link>
            </div>
          </div>
        </div>
        <div className="post-tab">
          <Tab.Container id="left-tabs-example" defaultActiveKey={"all"}>
            <Nav variant="pills" className="flex-column">
              <Nav.Item
                onClick={() => {
                  setEventKey(null);
                  setSearchKey("");
                }}
              >
                <Nav.Link eventKey={"all"} active={!eventKey}>
                  <span className="tab-name">All</span>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item
                onClick={() => {
                  setEventKey("freebies");
                  setSearchKey("");
                }}
              >
                <Nav.Link
                  eventKey={"freebies"}
                  active={eventKey === "freebies"}
                >
                  <span className="tab-name">Freebies</span>
                  <span className="count">
                    {freebiesCount?.deals_aggregate?.aggregate?.count}
                  </span>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item
                onClick={() => {
                  setEventKey("discount");
                  setSearchKey("");
                }}
              >
                <Nav.Link
                  eventKey={"discount"}
                  active={eventKey === "discount"}
                >
                  <span className="tab-name">Discount</span>
                  <span className="count">
                    {discountCount?.deals_aggregate?.aggregate?.count}
                  </span>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item
                onClick={() => {
                  setEventKey("buy_1_get_1_free");
                  setSearchKey("");
                }}
              >
                <Nav.Link
                  eventKey={"buy_1_get_1_free"}
                  active={eventKey === "buy_1_get_1_free"}
                >
                  <span className="tab-name">Buy 1 Get 1 Free</span>
                  <span className="count">
                    {buy_1_get_1_freeCount?.deals_aggregate?.aggregate?.count}
                  </span>
                </Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content>
              <Tab.Pane eventKey={"all"}>
                {!dealsLoading && deals && deals.deals && deals.deals.length ? (
                  <DealList
                    setCurrentDealId={setCurrentDealId}
                    setModalShowD={setModalShowD}
                    deals={deals.deals}
                  />
                ) : dealsLoading ? (
                  <div className="spinner-cover">
                    <Spinner
                      animation="border"
                      className="spinner"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </div>
                ) : dealsError ? (
                  "some error occurred..."
                ) : (
                  <div className="data-not-found">No Data Found...</div>
                )}
              </Tab.Pane>
              <Tab.Pane eventKey={"freebies"}>
                {!dealsLoading && deals && deals.deals && deals.deals.length ? (
                  <DealList
                    setCurrentDealId={setCurrentDealId}
                    setModalShowD={setModalShowD}
                    deals={deals.deals}
                  />
                ) : dealsLoading ? (
                  <div className="spinner-cover">
                    <Spinner
                      role="status"
                      className="spinner"
                      animation="border"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </div>
                ) : dealsError ? (
                  "some error occurred..."
                ) : (
                  <div className="data-not-found">No Data Found...</div>
                )}
              </Tab.Pane>
              <Tab.Pane eventKey={"discount"}>
                {!dealsLoading && deals && deals.deals && deals.deals.length ? (
                  <DealList
                    deals={deals.deals}
                    setModalShowD={setModalShowD}
                    setCurrentDealId={setCurrentDealId}
                  />
                ) : dealsLoading ? (
                  <div className="spinner-cover">
                    <Spinner
                      role="status"
                      className="spinner"
                      animation="border"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </div>
                ) : dealsError ? (
                  "some error occurred..."
                ) : (
                  <div className="data-not-found">No Data Found...</div>
                )}
              </Tab.Pane>
              <Tab.Pane eventKey={"buy_1_get_1_free"}>
                {!dealsLoading && deals && deals.deals && deals.deals.length ? (
                  <DealList
                    setModalShowD={setModalShowD}
                    setCurrentDealId={setCurrentDealId}
                    deals={deals.deals}
                  />
                ) : dealsLoading ? (
                  <div className="spinner-cover">
                    <Spinner
                      className="spinner"
                      animation="border"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </div>
                ) : dealsError ? (
                  "some error occurred..."
                ) : (
                  <div className="data-not-found">No Data Found...</div>
                )}
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </section>
    </MainContainer>
  );
};

export default DealLayout;
